import { recodeNow } from "../../../../components/indexDB/indexDBStora";

export const createTransaction = async (id, currentTime, response, transaction) => {
    if(!id || !currentTime || !response || !transaction) return false
    const transactionRecord = {
        ...transaction,
        batchId: id,
        createdAt: currentTime,
        transactionType: transaction.transactionType || "IN",
        qty: response.total,
        unit: response.type
    };
    await recodeNow(transactionRecord, "transactionBatch");
    
    return true;
};